import clsx from "clsx";
import { useEffect, useState } from "react";
import useAllBuildings from "../../../../../../../hooks/UseAllBuildings";
import useAllMaps from "../../../../../../../hooks/UseAllMaps";
import useAllResources from "../../../../../../../hooks/UseAllResources";
import useAllUnits from "../../../../../../../hooks/UseAllUnits";
import useProject from "../../../../../../../hooks/UseProject";
import {
  Building,
  MapType,
  Resource,
  Unit,
} from "../../../../../../types/project";
// import useKeypress from "react-use-keypress";
import "./ElementPanel.scss";

export default function ElementPanel({
  projectId,
  activeElement,
  setActiveElement,
  onGoToManagerClick,
}: {
  projectId: string;
  activeElement?: MapType | Unit | Building | Resource;
  setActiveElement: React.Dispatch<
    React.SetStateAction<MapType | Unit | Building | Resource | undefined>
  >;
  onGoToManagerClick: () => void;
}) {
  const [mainConfigPanelVisible, setMainConfigPanelVisible] = useState(true);

  const { data: maps, status: mapsStatus, addMap } = useAllMaps({ projectId });
  const {
    data: units,
    status: unitsStatus,
    addUnit,
  } = useAllUnits({ projectId });
  const {
    data: buildings,
    status: buildingsStatus,
    addBuilding,
  } = useAllBuildings({ projectId });
  const {
    data: resources,
    status: resourcesStatus,
    addResource,
  } = useAllResources({ projectId });
  const {
    data: project,
    status: projectStatus,
    updateProject,
  } = useProject({
    id: projectId,
  });

  useEffect(() => {
    setActiveElement(maps[0]);
  }, [projectId]);

  //   useKeypress(["Control", "Backslash"], () => {
  //     setMainConfigPanelVisible((current) => !current);
  //   });

  useEffect(() => {
    // const e = window.addEventListener("keypress", (e) => {
    //   console.log("E:", e);
    // });

    return () => {
      //   window.removeEventListener("keypress", e);
      //   removeEventListener("keypress", window);
    };
  }, []);

  if (
    mapsStatus !== "success" &&
    unitsStatus !== "success" &&
    buildingsStatus !== "success" &&
    resourcesStatus !== "success"
  ) {
    return <></>;
  }

  return (
    <div
      className={clsx("panel", "panel-main", {
        active: mainConfigPanelVisible,
      })}
    >
      <div
        className={clsx(
          "toggle-visibility-button",
          "panel-main-visibility-button",
          {
            active: !mainConfigPanelVisible,
          }
        )}
        onClick={() => {
          setMainConfigPanelVisible((current) => !current);
        }}
      >
        <img
          src="ui/toggle-panel.svg"
          className={clsx("toggle-visibility-icon", "main", {
            active: !mainConfigPanelVisible,
          })}
        />
      </div>
      <div className={clsx("main-panel-menu")}>
        <div className={clsx("project-name")}>{project.name}</div>
        <div className={clsx("project-menu-heading")}>Maps</div>
        <div
          className={clsx("project-menu-heading-add")}
          onClick={() => {
            addMap((mapId) => {
              updateProject({
                projectId,
                values: {
                  maps: [...maps, mapId],
                },
              });
            });
          }}
        >
          Add
        </div>
        {maps.map((map) => (
          <div
            className={clsx("project-menu-item", {
              active: activeElement?.id === map.id,
            })}
            onClick={() => {
              setActiveElement(map);
            }}
            key={map.id}
          >
            {map.name}
          </div>
        ))}

        <div className={clsx("project-menu-heading")}>Units</div>
        <div
          className={clsx("project-menu-heading-add")}
          onClick={() => {
            addUnit((unitId) => {
              updateProject({
                projectId,
                values: {
                  units: [...units, unitId],
                },
              });
            });
          }}
        >
          Add
        </div>
        {units.map((unit) => (
          <div
            className={clsx("project-menu-item", {
              active: activeElement?.id === unit.id,
            })}
            onClick={() => {
              setActiveElement(unit);
            }}
            key={unit.id}
          >
            {unit.name}
          </div>
        ))}

        <div className={clsx("project-menu-heading")}>Buildings</div>
        <div
          className={clsx("project-menu-heading-add")}
          onClick={() => {
            addBuilding((buildingId) => {
              updateProject({
                projectId,
                values: {
                  buildings: [...buildings, buildingId],
                },
              });
            });
          }}
        >
          Add
        </div>
        {buildings.map((building) => (
          <div
            className={clsx("project-menu-item", {
              active: activeElement?.id === building.id,
            })}
            onClick={() => {
              setActiveElement(building);
            }}
            key={building.id}
          >
            {building.name}
          </div>
        ))}

        <div className={clsx("project-menu-heading")}>Resources</div>
        <div
          className={clsx("project-menu-heading-add")}
          onClick={() => {
            addResource((resourceId) => {
              updateProject({
                projectId,
                values: {
                  resources: [...resources, resourceId],
                },
              });
            });
          }}
        >
          Add
        </div>
        {resources.map((resource) => (
          <div
            className={clsx("project-menu-item", {
              active: activeElement?.id === resource.id,
            })}
            onClick={() => {
              setActiveElement(resource);
            }}
            key={resource.id}
          >
            {resource.name}
          </div>
        ))}
      </div>
      <div
        className={clsx("back-button")}
        onClick={() => onGoToManagerClick()}
        title="Go back to project manager"
      >
        GO BACK
      </div>
    </div>
  );
}
